import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CommentTile from './CommentTile';
import NewCommentTile from './NewCommentTile';

function CommentList({ collectionGroupId, documentId }) {

  const [comments, setComments] = useState([]);

  const getComments = async () => {
    let url = "/api/v1/comments/byDocument/" + collectionGroupId + "/" + documentId;
    axios
      .get(url)
      .then(function (response) {
        if (response.status === 200) {
          setComments(response.data);
        } else {
          setComments([]);
        }
      })
      .catch((err) => setComments([]));
  }


  useEffect(() => {
    getComments();
  }, [])

  const findObject = (arr, key, value) => {
    for (const item of arr) {
      if (item && typeof item === 'object') {
        if (item[key] === value) {
          return item;
        }
        if (Array.isArray(item.children)) {
          const result = findObject(item.children, key, value);
          if (result) {
            return result;
          }
        }
      }
    }
    return undefined;
  }


  return (
    <div>
      {comments.length === 0 ? (
        <h3>Start the debate</h3>
      ) : <h3> </h3>}
      {comments.length === 0 ? (
        <NewCommentTile collectionGroupId={collectionGroupId} documentId={documentId} parentId={0} commentEntry={null} idx={0} />
      ) : (
        comments.map((commentEntry, index) => (
          <CommentTile key={commentEntry.id ?? "empty"} collectionGroupId={collectionGroupId} documentId={documentId} parentId={0} commentEntry={commentEntry} idx={index} />
        ))
      )}

    </div>
  )
}

export default CommentList
